/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Subscription_Past_DueInputs */

const en_my_payments_subscription_past_due = /** @type {(inputs: My_Payments_Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment failed: update your card`)
};

const pl_my_payments_subscription_past_due = /** @type {(inputs: My_Payments_Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność nieudana: zaktualizuj kartę`)
};

/**
* | output |
* | --- |
* | "Payment failed: update your card" |
*
* @param {My_Payments_Subscription_Past_DueInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_subscription_past_due = /** @type {((inputs?: My_Payments_Subscription_Past_DueInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Subscription_Past_DueInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_subscription_past_due(inputs)
	return en_my_payments_subscription_past_due(inputs)
});